export default {
  names: {
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    firstName: 'Nombre',
    lastName: 'Apellido',
    newEmail: 'Nuevo correo electrónico',
    confirmEmail: 'Confirmar nuevo correo electrónico',
    newPassword: 'Nueva contraseña'
  }
}
